import React, { useState } from 'react'
import { connect } from 'react-redux'
import { Menu, MenuItem, MenuButton, SubMenu, } from '@szhsin/react-menu'
import { Link } from 'react-router-dom'
import Collapsible from './components/Collapsible'
// import { setLang } from '../../redux/actions/settings'
import { getURLByRouteName } from '../../utils/routes'
import { buildProductMenu } from './utils'

import { text, sections } from './locals'
import logo from '../../assets/images/sanfer_logo.png'
import searchIcon from '../../assets/images/svg_icons/Search.svg'
import { ReactComponent as MenuIcon } from '../../assets/images/svg_icons/Menu.svg'
import '@szhsin/react-menu/dist/index.css'
import './index.css'


const DownArrow = () => <div dangerouslySetInnerHTML={{
  __html: `<?xml version="1.0" encoding="UTF-8"?>
<svg width="11px" height="6px" viewBox="0 0 11 6" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>down-arrow (1) copy 5</title>
    <g id="Symbols" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Menu" class='arrow-color' transform="translate(-430.000000, -43.000000)"  fill-rule="nonzero">
            <g id="Group-4" transform="translate(240.000000, 38.000000)">
                <g id="Group-3" transform="translate(115.000000, 0.000000)">
                    <g id="down-arrow-(1)-copy-5" transform="translate(75.000000, 5.000000)">
                        <path d="M10.0956359,0.104347826 C9.95505262,-0.0347826087 9.72660481,-0.0347826087 9.58602155,0.104347826 L5.1049299,4.54782609 L0.615051795,0.104347826 C0.474468528,-0.0347826087 0.246020718,-0.0347826087 0.105437451,0.104347826 C-0.0351458169,0.243478261 -0.0351458169,0.469565217 0.105437451,0.608695652 L4.84133627,5.29565217 C4.91162791,5.36521739 4.99949245,5.4 5.09614344,5.4 C5.18400799,5.4 5.28065898,5.36521739 5.35095062,5.29565217 L10.0868494,0.608695652 C10.2362192,0.469565217 10.2362192,0.243478261 10.0956359,0.104347826 Z" id="Path"></path>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>`}} />

const Header = props => {
  const { lang } = props.settings
    , { list } = props.products
    , { searchText = '', onSearchTextChange = () => null, onSearch = () => null } = props
    , [menuVisible, setMenuVisible] = useState(false)
    , headerLinks = sections[lang]
      ? Object.values(sections[lang])
      : []

  /* const onSetLang = () => {
    props.dispatch(setLang(lang === 'es' ? 'en' : 'es'))
  } */

  const getSubItems = key => {
    switch (key) {
      case 'products': {
        let productsCategory = buildProductMenu(list, getURLByRouteName('products'))
        return productsCategory
      }
      default: return []
    }
  }

  const renderSubLinks = (subLinks, index) => {
    let hasSubItems = !!(subLinks.subItems && subLinks.subItems.length)
      , subItems = subLinks.subItems
    if (typeof subLinks.subItems === 'string') subItems = getSubItems(subItems)
    if (hasSubItems && subItems.length) return <SubMenu key={index} label={subLinks.title}>
      {subItems.map(renderSubLinks)}
    </SubMenu>
    return <MenuItem key={index}>
      <Link to={subLinks.url}>{subLinks.title}</Link>
    </MenuItem>
  }

  const renderLink = (link, index) => {
    let hasSubItems = !!(link.subItems && link.subItems.length)
    if (hasSubItems) return <Menu key={index} menuButton={<MenuButton>{link.title} <DownArrow /></MenuButton>}>
      {link.subItems.map(renderSubLinks)}
    </Menu>

    return <Link key={index} className='rc-menu-button' to={link.url}>{link.title}</Link>
  }

  return <React.Fragment>
    <header className='header'>
      <div className='header__submenu'>
        <div className='header__submenu-external'>
          <a href='https://fundacionsanfer.org/'>{text[lang].foundation}</a>
          <a href='https://mx.linkedin.com/company/sanfer'>{text[lang].job}</a>
        </div>
        {/* <div className='header__submenu-lang-selector'>
          <img alt='country-flag' src={`https://www.countryflags.io/${lang === 'en' ? 'mx' : 'us'}/flat/64.png`} />
          <span onClick={onSetLang} >{text[lang].lang}</span>
        </div> */}
      </div>
      <div className='header__menu'>
        <div className='header__nav'>
          <Link to='/' className='logo'>
            <img src={logo} alt='SANFER' />
          </Link>
          <MenuIcon className='header__menu-btn' onClick={() => setMenuVisible(true)} />
          <nav>
            {headerLinks.map(renderLink)}
          </nav>
        </div>
        <div className='header__search'>
          <input placeholder='Buscar'
            value={searchText}
            onChange={e => onSearchTextChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') onSearch()
            }}
          />
          <img src={searchIcon} alt='search' onClick={onSearch} />
        </div>
      </div>
    </header>
    <div className={`header__mobile-menu transition ${menuVisible ? 'active' : ''}`}>
      <div className='header__menu'>
        <div className='header__nav'>
          <Link to='/' className='logo'>
            <img src={logo} alt='SANFER' />
          </Link>
          <MenuIcon className='header__menu-btn' onClick={() => setMenuVisible(false)} />
        </div>
      </div>
      {/* <div className='header__search'>
        <input placeholder='Buscar'
          value={searchText}
          onChange={e => onSearchTextChange(e.target.value)}
        />
        <img src={searchIcon} alt='search' onClick={onSearch} />
      </div> */}
      <nav className='header__mobile-nav'>
        {
          headerLinks.map((navItem, index) => {
            return navItem.subItems
              ? <Collapsible key={index} {...navItem} />
              : <div className='header__mobile-item' key={index}>
                <Link to={navItem.url}>{navItem.title}</Link>
              </div>
          })
        }
      </nav>
      <div className='header__mobile-submenu'>
        <div className='header__mobile-submenu-external'>
          <a href='https://fundacionsanfer.org/'>{text[lang].foundation}</a>
          <span>/</span>
          <a href='https://mx.linkedin.com/company/sanfer'>{text[lang].job}</a>
        </div>
        {/* <div className='header__mobile-submenu-lang-selector'>
          <img alt='country-flag' src={`https://www.countryflags.io/${lang === 'en' ? 'mx' : 'us'}/flat/64.png`} />
          <span onClick={onSetLang} >{text[lang].lang}</span>
        </div> */}
      </div>
    </div>
  </React.Fragment>
}
const mapStateToProps = state => ({
  settings: state.settings,
  products: state.products
})

export default connect(mapStateToProps)(Header)